module.exports = __webpack_public_path__ + "img/options2_2.452ddacd.png";